import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export enum ETabs {
  Todos = 1,
  Auto = 2,
  Compreensivo = 3,
  Vida = 4,
  Diversos = 5,
}

export interface PeriodoCustomizado {
  startDate: Date;
  endDate: Date;
  isCustom: true;
}

@Injectable({ providedIn: 'root' })
export class FiltroCotacoesRamoService {
  private tabSubject = new BehaviorSubject<ETabs>(ETabs.Todos);
  private clearSubject = new Subject<void>();
  private periodoSubject = new BehaviorSubject<number | "renovacao">(15);
  private origemSubject = new BehaviorSubject<number|string>('');
  private periodoCustomizadoSubject = new BehaviorSubject<PeriodoCustomizado | null>(null);

  currentTab$ = this.tabSubject.asObservable();
  clear$ = this.clearSubject.asObservable();
  periodo$ = this.periodoSubject.asObservable();
  origem$ = this.origemSubject.asObservable();
  periodoCustomizado$ = this.periodoCustomizadoSubject.asObservable();

  changeTab(tab: ETabs) {
    this.tabSubject.next(tab);
  }

  askClear() {
    this.clearSubject.next();
  }

  changePeriodo(periodo: number | "renovacao") {
    this.periodoSubject.next(periodo);
    this.periodoCustomizadoSubject.next(null);
  }

  changePeriodoCustom(startDate: Date, endDate: Date) {
    const periodoCustomizado: PeriodoCustomizado = {
      startDate,
      endDate,
      isCustom: true
    };
    this.periodoCustomizadoSubject.next(periodoCustomizado);
  }

  changeOrigem(origem: number | string){
    this.origemSubject.next(origem);
  }

  clearFilters(){
    this.periodoSubject.next(15);
    this.periodoCustomizadoSubject.next(null);
    this.origemSubject.next('');
  }
}
